import React from 'react';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormROChipValue from '../../../library/form/components/FormROChipValue';
import DocCardContainer from '../../cmn/DocCardContainer'

const ProAddressRow = (props) => {
    const { formObject, rowKey } = props;
    return (
            <DocCardContainer formObject={formObject} rowKey={rowKey} >
                <div>
                    <div className="uiCardHeader uiRowHeight1">
                        <FormROChipValue
                            format="#"
                            formObject={formObject}
                            rowKey={rowKey}
                            hideIfEmpty={true}
                            action={{ paramName: "addType" }}
                            id='svAddType'
                            className=""
                        />
                    </div>
                    <div className="uiRowHeight2" id="svAddress">
                        <FormROValue
                            format="#"
                            formObject={formObject}
                            rowKey={rowKey}
                            action={{ paramName: "addPart" }}
                        />
                        <FormROValue
                            format="#"
                            formObject={formObject}
                            rowKey={rowKey}
                            action={{ paramName: "addCountry" }}
                            id="svLandmark"
                        />
                    </div>
                </div>
            </DocCardContainer>
    )
}

export default ProAddressRow